import React from "react";

import useIsAr from "../../../Hooks/useIsAr";
import { ReactComponent as RequiredIcon } from "../../../assets/images/kpi-req-icon.svg";
import { ReactComponent as UpdateIcon } from "../../../assets/images/kpi-update-icon.svg";

import "./style.scss";

const PerspectiveKPIs = ({ items, KPIsStatus, onShowPopup }) => {
  const [isAr] = useIsAr();
  return (
    <div className="general-dash-division">
      {items.map((item, index) => (
        <div className="general-dash-division__item" key={index}>
          <h4>
            {`${isAr ? item.ArabicName : item.EnglishName} ( ${
              item.KPICount
            } )`}
          </h4>
          <div className="general-dash-division__statues">
            <div className="bar-status">
              {item.KPIByStatuses?.filter((_item) => _item.Count > 0)?.map(
                (_item, _index) => (
                  <div
                    title={_item?.Count}
                    className="cursor"
                    onClick={() => onShowPopup(_item?.KPIs)}
                    style={{
                      width: (_item?.Count / item.KPICount) * 98 + "%",
                      backgroundColor: KPIsStatus?.find(
                        (status) => status.Code === _item.Status
                      ).Color,
                    }}
                    key={_index}
                  >
                    {_item?.Count}
                  </div>
                )
              )}
            </div>
            <div className="btn-count-required">
              <RequiredIcon />
              <span>{item.RequireUpdateKPIs}</span>
              <UpdateIcon />
              <span>{item.UpdatedKPIs}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PerspectiveKPIs;
